export default __webpack_public_path__ + "static/media/inline6.6ea44137.png";